const COMMUNITY_GROUP_CHILD_SEGMENTS = new Set([
  'home',
  'learning',
  'settings',
  'members',
  'events',
  'leaderboard',
  'about',
  'channels',
  'conversations',
  'content-unavailable',
  'plans',
])

export function splitRoutePathSegments(path: string): string[] {
  return path.replace(/\/+$/, '').split('/').filter(Boolean)
}

function groupSlugSegmentIndex(segments: string[]): number {
  if ((segments[0] === 'communities' || segments[0] === 'courses') && segments[1] === 'groups') {
    return 2
  }
  return 0
}

/** First path segment after [groupSlug] (communities, courses-app groups, or GoKollab). */
export function firstSegmentAfterGroupSlug(path: string): string | undefined {
  const segments = splitRoutePathSegments(path)
  return segments[groupSlugSegmentIndex(segments) + 1]
}

/**
 * Top-level `/courses/...` app routes. Excludes GoKollab groups whose slug is `courses`
 * or `courses-*` (`/courses/channels/...`, `/courses-MD/home`).
 */
export function isCoursesAppPath(path: string): boolean {
  const segments = splitRoutePathSegments(path)
  if (segments[0] !== 'courses') return false
  const second = segments[1]
  return !second || !COMMUNITY_GROUP_CHILD_SEGMENTS.has(second)
}

export function hasConsecutivePathSegments(path: string, left: string, right: string): boolean {
  const segments = splitRoutePathSegments(path)
  for (let i = 0; i < segments.length - 1; i++) {
    if (segments[i] === left && segments[i + 1] === right) return true
  }
  return false
}

export function isCoursesContextPath(path: string): boolean {
  return isCoursesAppPath(path) || hasConsecutivePathSegments(path, 'learning', 'courses')
}
